<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >

    <div v-if="stickers !== null">

      <!-- Table Container Card -->
      <b-card
          class="mb-2"
          no-body
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row class="justify-content-between">
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="2"
            >
              <label>نمایش :</label>
              <v-select
                  v-model="perPage"
                  :clearable="false"
                  :options="perPageOptions"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>
            <b-col>
              <b-button
                  v-b-modal.modal-upload
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  class="col-12 col-md-2 mr-auto"
                  variant="primary"
              >
                + افزودن استیکر
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col cols="12">
            <b-row>
              <b-card
                  v-for="(sticker,idx) in stickers"
                  class="col-2 box-shadow-0 px-1 bg-transparent"
                  no-body
                  tag="article"
              >
                <b-link to='#'>
                  <b-img
                      :src="sticker.url"
                      class="card-img-top"
                      style="max-height: 20rem"
                  />
                </b-link>
                <b-card-body class="px-2 bg-white rounded-bottom">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="w-100">
                      <b-link
                          v-b-modal.modal-delete
                          class="w-100 btn btn-danger font-weight-bold text-white mr-1"
                          @click="showModal(sticker.id)"
                      >
                        <feather-icon
                            class="mr-25"
                            icon="TrashIcon"
                        />
                        حذف
                      </b-link>
                    </div>
                  </div>
                </b-card-body>
              </b-card>
            </b-row>
          </b-col>

          <b-col
              v-if="!stickers || stickers.length === 0"
              class="d-flex align-items-center justify-content-center"
              cols="12"
          >
            <h3>هیچ آیتمی یافت نشد !</h3>
          </b-col>
        </b-row>
      </div>


      <div class="mx-2 mb-2">
        <b-row>
          <b-col
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
              cols="12"
              sm="6"
          >
            <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
          </b-col>
          <!-- Pagination -->
          <b-col
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              cols="12"
              sm="6"
          >

            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalCounts"
                class="mb-0 mt-1 mt-sm-0"
                first-number
                last-number
                next-class="next-item"
                prev-class="prev-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon"
                              size="18"
                              style="transform: rotate(180deg)"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Delete Modal  -->
    <b-modal
        id="modal-delete"
        cancelTitle="انصراف"
        centered
        ok-title="حذف"
        @ok="deleteSticker(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>

    <!-- Upload Media Modal   -->
    <b-modal
        id="modal-upload"
        centered
        ok-title="آپلود"
        @ok="uploadSubMedia"
        cancelTitle="بستن"
        title="آپلود استیکر"
    >
      <b-form>
        <b-button
            class="mt-2 col-12 col-md-4"
            variant="warning"
            @click="$refs.refInputEl3.click()"
        >
          <input
              ref="refInputEl3"
              class="d-none"
              type="file"
              @change="select"
          >
          <span class="">بارگذاری</span>
        </b-button>
      </b-form>
      <b-progress
          v-if="uploaded2 !== 0 && uploaded2 !== 100"
          :value="uploaded2"
          class=" mt-2"
          max="100"
          variant="primary"
      />

      <b-alert
          :show="uploaded2 === 100"
          class="col-12"
          variant="success"
      >
        <div class="alert-body mt-2">
          <feather-icon
              class="mr-25"
              icon="CheckIcon"
          />
          <span class="ml-25">فایل شما آپلود شده است.</span>
        </div>
      </b-alert>
      <b-alert
          :show="errorAlert"
          class="col-12"
          variant="danger"
      >
        <div class="alert-body mt-2">
          <feather-icon
              class="mr-25"
              icon="CloseIcon"
          />
          <span class="ml-25">آپلود فایل با مشکل مواجه شد!</span>
        </div>
      </b-alert>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BCardBody,
  BCol,
  BForm,
  BImg,
  BLink,
  BModal,
  BOverlay,
  BPagination,
  BProgress,
  BRow,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from "@/libs/Helper";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {StickersDeleteRequest, StickersGetListRequest} from "@/libs/Api/Prize";
import axios from "axios";
import {getUserData} from "@/auth/utils";

export default {
  title: "لیست استیکرها - پنل ادمین ذهن آرایی",
  name: "StickersList",
  data() {
    return {
      stickers: null,
      baseUrl: Helper.baseUrl,
      totalCounts: null,
      currentPage: 1,
      perPage: 12,
      IsActive: '',
      publishDate: '',
      endDate: '',
      overlay: false,
      perPageOptions: [12,24,36,48,60],
      deleteItem: null,
      file: null,
      errorAlert: false,
      uploaded2: 0,
    }
  },
  computed: {
    formData() {
      let formData = new FormData;

      if (this.file !== null) {
        formData.set('file', this.file, `${this.file.name}`);
      }
      return formData;
    },
    config2() {
      return {
        method: 'POST',
        data: this.formData,
        withCredentials:true,
        url: Helper.baseUrl + 'api/Sticker/CreateSticker',
        headers: {
          'Content-Type': 'application/octet-stream',
          // 'Authorization': getUserData().token,
          'Token': getUserData().token,
        },
        onUploadProgress: progressEvent => {
          this.uploaded2 = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      };
    },
  },
  async created() {
    await this.getAll(this.perPage, this.currentPage)
  },
  methods: {
    select(event) {
      this.file = event.target.files.item(0);
    },
    uploadSubMedia() {
      let _this = this;
      axios(_this.config2).then(response => {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `فایل با موفقیت آپلود شد.`,
          },
        })
        window.location.reload();
      }).catch(error => {
        _this.errorAlert = true;
        console.log(error);
      });
    },
    async getAll(count, pageNumber) {
      let _this = this;
      _this.overlay = true;
      let data = {
        page: pageNumber,
        count: count,
      }

      let stickersGetListRequest = new StickersGetListRequest(_this);
      stickersGetListRequest.setParams(data);
      await stickersGetListRequest.fetch(function (content) {
        _this.overlay = false;
        _this.stickers = content.data.data;
        _this.totalCounts = content.data.totalCount;
      }, function (error) {
        _this.overlay = false;
        console.log(error);
      })
    },
    async deleteSticker(param) {
      let _this = this;

      let stickersDeleteRequest = new StickersDeleteRequest(_this);
      stickersDeleteRequest.setParams({ id: param });
      await stickersDeleteRequest.fetch(function (content) {
            _this.$toast({
              component: ToastificationContent,
              position: 'bottom-center',
              props: {
                title: `عملیات موفق`,
                icon: 'CheckIcon',
                variant: 'success',
                text: `استیکر حذف شد.`,
              },
            })
            _this.deleteItem = null;
            _this.getAll(_this.perPage, _this.currentPage);
          },
          function (error) {
            console.log(error)
          })
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param;
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getAll(nv, this.currentPage);
    },
    currentPage: function (nv, ov) {
      this.getAll(this.perPage, nv);
    },
  },
  components: {
    BForm, BAlert, BProgress,
    BCard,
    BRow,
    BCol,
    BButton,
    BLink,
    BPagination,
    BOverlay,
    BImg,
    BModal,
    BCardBody,
    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
